/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appOkta_viewer$ref: FragmentReference;
declare export opaque type appOkta_viewer$fragmentType: appOkta_viewer$ref;
export type appOkta_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +oktaEnabled: ?boolean,
    +AADEnabled: ?boolean,
    +oneloginEnabled: ?boolean,
    +scimUsernamePassword: ?string,
    +oktaClientId: ?string,
    +oktaClientSecret: ?string,
    +oktaUrl: ?string,
  |},
  +$refType: appOkta_viewer$ref,
|};
export type appOkta_viewer$data = appOkta_viewer;
export type appOkta_viewer$key = {
  +$data?: appOkta_viewer$data,
  +$fragmentRefs: appOkta_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appOkta_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "AADEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oneloginEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scimUsernamePassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaClientSecret",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oktaUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '2160f17eb0b0a3799fa706fa2fae738a';

module.exports = node;
